// extracted by mini-css-extract-plugin
module.exports = {"StorePage":"StorePage_StorePage__39k-F","PagePart":"StorePage_PagePart__1TBas","LeftSide":"StorePage_LeftSide__3vGKA","RightSide":"StorePage_RightSide__2ZEwJ"};